// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs {
  width: 100%;
  background-color: var(--ion-color-white);
  border-bottom: 1px solid var(--ion-color-lines);
  height: 50px;
}
.tabs .container-fixed {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tabs ion-tab-bar {
  overflow: auto;
  height: 48px;
  width: 100%;
  justify-content: flex-start;
}
.tabs ion-tab-button {
  --background: transparent;
  max-width: -moz-fit-content;
  max-width: fit-content;
  min-width: -moz-fit-content;
  min-width: fit-content;
  position: relative;
}
.tabs ion-tab-button ion-label {
  color: var(--ion-color-light);
  font-size: 15px;
  font-weight: 600;
}
.tabs ion-tab-button .notification-circle {
  width: 9px;
  height: 9px;
  background-color: var(--ion-color-danger);
  position: absolute;
  top: 3px;
  right: -8px;
  border-radius: 100%;
}
.tabs ion-tab-button .icon {
  width: 34px;
  margin-right: 9px;
}
.tabs ion-tab-button .icon.hover,
.tabs ion-tab-button .icon.selected {
  display: none;
}
.tabs ion-tab-button:hover ion-label {
  color: var(--ion-color-pink);
}
.tabs ion-tab-button:hover .icon {
  display: none;
}
.tabs ion-tab-button:hover .icon.hover {
  display: block;
}
.tabs ion-tab-button.router-link-active ion-label {
  color: var(--ion-color-pink);
}
.tabs ion-tab-button.router-link-active .icon {
  display: none;
}
.tabs ion-tab-button.router-link-active .icon.selected {
  display: block;
}
.tabs ion-tab-button.router-link-active .icon.hover {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/tabs/tabs.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,wCAAA;EACA,+CAAA;EACA,YAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACJ;AAEE;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;AAAJ;AAGE;EACE,yBAAA;EACA,2BAAA;EAAA,sBAAA;EACA,2BAAA;EAAA,sBAAA;EACA,kBAAA;AADJ;AAII;EACE,6BAAA;EACA,eAAA;EACA,gBAAA;AAFN;AAKI;EACE,UAAA;EACA,WAAA;EACA,yCAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;AAHN;AAMI;EACE,WAAA;EACA,iBAAA;AAJN;AAOI;;EAEE,aAAA;AALN;AASM;EACE,4BAAA;AAPR;AAUM;EACE,aAAA;AARR;AAUQ;EACE,cAAA;AARV;AAeM;EACE,4BAAA;AAbR;AAeM;EACE,aAAA;AAbR;AAeQ;EACE,cAAA;AAbV;AAgBQ;EACE,aAAA;AAdV","sourcesContent":[".tabs {\n  width: 100%;\n  background-color: var(--ion-color-white);\n  border-bottom: 1px solid var(--ion-color-lines);\n  height: 50px;\n\n  .container-fixed {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  ion-tab-bar {\n    overflow: auto;\n    height: 48px;\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  ion-tab-button {\n    --background: transparent;\n    max-width: fit-content;\n    min-width: fit-content;\n    position: relative;\n\n\n    ion-label {\n      color: var(--ion-color-light);\n      font-size: 15px;\n      font-weight: 600;\n    }\n\n    .notification-circle {\n      width: 9px;\n      height: 9px;\n      background-color: var(--ion-color-danger);\n      position: absolute;\n      top: 3px;\n      right: -8px;\n      border-radius: 100%;\n    }\n\n    .icon {\n      width: 34px;\n      margin-right: 9px;\n    }\n\n    .icon.hover,\n    .icon.selected {\n      display: none;\n    }\n\n    &:hover {\n      ion-label {\n        color: var(--ion-color-pink);\n      }\n\n      .icon {\n        display: none;\n\n        &.hover {\n          display: block;\n        }\n      }\n    }\n\n    &.router-link-active {\n\n      ion-label {\n        color: var(--ion-color-pink);\n      }\n      .icon {\n        display: none;\n\n        &.selected {\n          display: block;\n        }\n\n        &.hover {\n          display: none;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
